<template>
  <div
    class="smallPopover"
    :class="{ top: position == 'top', bottom: position == 'bottom' }"
  >
    <img
      class="triangle_popover"
      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/triangle_popover.png"
      alt=""
      v-if="position == 'bottom'"
    />
    <div class="text">
      {{ text }}
    </div>
    <img
      class="triangle_popover reverse"
      src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/triangle_popover.png"
      alt=""
      v-if="position == 'top'"
    />
  </div>
</template>

<script>
export default {
  props: ["position", "text"],
};
</script>

<style lang="scss" scoped>
@import "./smallPopover.scss";
</style>
